import React from "react";
import Button from "./Button";
import "./PaginatorButton.css";

const PaginatorButton = (props) => {
  if (!props.metadata) {
    return null;
  }

  if (props.metadata.get("after") && props.metadata.get("after") !== null) {
    return (
      <div className="PaginatorButton">
        <Button label="Load more" showLoading={props.showLoading} onClick={() => props.onNext(props.metadata.get("after"))}/>
      </div>
    )
  }

  return null;
}

PaginatorButton.defaultProps = {
  showLoading: false
}

export default PaginatorButton;